var React = require('react');

function BackArrowSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.02326 0.500425C9.39632 0.489959 9.757 0.705891 9.91762 1.07626L9.9188 1.07898C10.0803 1.45784 9.98571 1.88991 9.70229 2.1641L5.30843 6.49884L9.70103 10.8323C9.95126 11.0711 10.0598 11.4364 9.96705 11.7867C9.87455 12.1343 9.60565 12.3874 9.28558 12.4703C8.9674 12.5523 8.62219 12.4622 8.3825 12.2177L3.28778 7.19152C2.90375 6.81266 2.90375 6.18502 3.28778 5.80615L8.38414 0.778372C8.55657 0.605596 8.78585 0.507469 9.02326 0.500425Z","fill":"#001D3B"}));
}

BackArrowSmall.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = BackArrowSmall;

BackArrowSmall.default = BackArrowSmall;
